// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"231":"feed","263":"widget","791":"video"}[chunkId] + "." + {"231":"b77d50ecb9907bf00419","263":"5e7c39891aa8163ae299","791":"20dbf30a6a24c68f32df"}[chunkId] + ".js";
};